export default __webpack_public_path__ + "static/heroSectionBg-d25368737595cb5859014b929ae9a1ba.png";